
import React from 'react';
import { connect } from 'react-redux';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import TextField from '@material-ui/core/TextField';
import ButtonComponent from 'components/buttons/button';
import IntlMessageComponent from 'components/formatters/intlMessage';
import MissingDocNote from './model';

import { handleApiFormResponse } from 'lib/forms';

type MissingDocumentsDialogComponentProps = {
  activeCompanyId: number;
  missingDocumentsTypes: string[];
  missingDocumentsNotes: MissingDocNote[];
  missingDocumentsErrors: string[];
  onClose: () => void;
  onSuccess: () => void;
  handleChange: (docType: string) => (event: SyntheticInputEvent<HTMLInputElement>) => void;
}

type MissingDocumentsDialogComponentState = {
  missingDocumentsNote: string;
  isProcessing: boolean;
}

class MissingDocumentsDialogComponent extends React.Component<MissingDocumentsDialogComponentProps, MissingDocumentsDialogComponentState> {

  constructor(props) {
    super(props);
    this.state = {
      missingDocumentsNote: null,
      isProcessing: false,
    };
  }

  render() {
    return (
      <Dialog open onClose={this.props.onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <IntlMessageComponent id="component.subscription.missingdocs.title" />
        </DialogTitle>

        {this.state.isProcessing &&
          <DialogContent>
            <Box align="center" p={5}>
              <CircularProgress size={60} />
            </Box>
          </DialogContent>
        }

        {!this.state.isProcessing &&
          <React.Fragment>
            <DialogContent>
              <IntlMessageComponent id={"component.subscription.missingdocs.notes"} />
              {this.props.missingDocumentsTypes.map((d) => {
                return <TextField
                  id={"component.subscription.missingdocs.notetext" + d}
                  label={<IntlMessageComponent id={"component.subscription.missingdocs." + d} />}
                  error={this.props.missingDocumentsErrors?.find(e => e === d)}
                  helperText={this.props.missingDocumentsErrors?.find(e => e === d) ?
                    <IntlMessageComponent id={"component.subscription.missingnote"} /> : ''}
                  value={this.props.missingDocumentsNotes.find(d => d.missingDocType === d)?.missingDocNote}
                  onChange={this.props.handleChange(d)}
                  fullWidth
                  margin="normal"
                  required
                />
              })}
            </DialogContent>

            <DialogActions>
              <ButtonComponent
                color="default"
                onClick={this.props.onClose}
              ><IntlMessageComponent id="general.cancel" /></ButtonComponent>

              <ButtonComponent
                color="primary"
                onClick={this.props.onSuccess}
              ><IntlMessageComponent id="general.submit" /></ButtonComponent>
            </DialogActions>
          </React.Fragment>
        }
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id
});

export default connect(mapStateToProps)(MissingDocumentsDialogComponent);
